// extracted by mini-css-extract-plugin
export default {"back":"SMLBackLink_back__1GBD4"};